import React, { useEffect, useRef, useState } from "react";
import { TinyBtnProps } from "@/types/ui-kit/buttons";
import { BaseTooltip } from "@/components/ui-kit/Buttons/BaseTooltip";
import autoAnimate from "@formkit/auto-animate";
import Image from "next/image";

export const TinyPlayAudioButton: React.FC<TinyBtnProps> = ({ onClick, short }) => {
  const [isPlayed, setIsPlayed] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const parent = useRef(null);

  useEffect(() => {
    parent.current && autoAnimate(parent.current);
  }, [parent]);

  const currentPlayAudioIcon = () => {
    if (isPlayed) {
      return "/assets/images/icons/new-play-audio-active.svg";
    }
    if (isHovered) {
      return "/assets/images/icons/new-play-audio-hovered.svg";
    }
    return "/assets/images/icons/new-play-audio.svg";
  };

  return (
    <button
      onClick={() => {
        setIsPlayed(!isPlayed);
        onClick?.();
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      aria-label="Přehrát"
      ref={parent}
      className={`relative flex max-w-[36px] items-center justify-center rounded-full border border-gray-300 bg-white dark:border-white-50 dark:bg-dark md:max-w-[50px] ${
        short ? "w-[36px]" : "w-[36px] md:w-[50px]"
      } py-1 transition-colors ease-in-out`}
    >
      <BaseTooltip visible={isHovered} content="Přehrát" />
      <Image
        src={currentPlayAudioIcon()}
        alt="Bookmark icon"
        className={`h-[16px] w-[16px] ${!isHovered && !isPlayed ? "dark:invert" : ""}`}
        width={16}
        height={16}
        aria-hidden={true}
      />
    </button>
  );
};
